import React from 'react'
import Button from "./Button";
import classNames from 'classnames'
import {ButtonProps} from './util/ButtonProps'

const SolidButton = (props: ButtonProps) => {
  const {className, ...rest} = props
  return <Button className={classNames("ss-button-primary", className)} {...rest} />
}

export default SolidButton
